import { IUserState } from '../../types/redux/user';

const initialState: IUserState = {
  userId: null,
  userType: null,
  phones: null,
};

export function userReducer(state: IUserState = initialState) {
  return state;
}
